module.exports = __webpack_public_path__ + "img/top2.c6ddcdca.jpg";